import React from 'react';
import { IconProps } from '../types/types';

const ORCL: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="#F80000" d="M0 0h18v18H0z"/><rect x="4" y="6" rx="3" stroke="#fff" strokeWidth="2"/></svg>
);

export default ORCL;